import { useEffect, useState } from 'react'

import { apiGetVersion } from '@/features/version/api/api-get-version'
import {
  isProductionDeployEnv,
  type VersionInfo,
} from '@/features/version/types/version'

const formatShortSha = (revision: string | undefined) => {
  if (!revision) {
    return null
  }

  return revision.slice(0, 7)
}

const formatTooltip = (info: VersionInfo) => {
  if (!info.git.build_date) {
    return undefined
  }

  return [info.git.revision, info.git.ref, info.git.build_date]
    .filter(Boolean)
    .join(' · ')
}

export const BuildInfo = () => {
  const [info, setInfo] = useState<VersionInfo | null>(null)

  useEffect(() => {
    let cancelled = false

    void apiGetVersion()
      .then((payload) => {
        if (!cancelled) {
          setInfo(payload)
        }
      })
      .catch(() => {
        // Keep the corner empty when version data is unavailable.
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (!info || isProductionDeployEnv(info.deploy_env)) {
    return null
  }

  const shortSha = formatShortSha(info.git.revision)
  const label = [info.version, shortSha, info.deploy_env].filter(Boolean).join(' · ')

  if (!label) {
    return null
  }

  return (
    <p
      className="mt-5 text-xs text-muted-foreground"
      title={formatTooltip(info)}
    >
      {label}
    </p>
  )
}
